import { LottieRefCurrentProps } from 'lottie-react'
import { RefObject } from 'react'

export enum AnimationSteps {
  One = 1,
  Two = 2,
  Three = 3,
}

export type TimeoutId = ReturnType<typeof setTimeout> | ReturnType<typeof setInterval> | null

export interface ExplainerProps {
  lottieRef: RefObject<LottieRefCurrentProps & { currentTime: number }>
  activeStep: AnimationSteps
  handlePlayStep: (value: AnimationSteps) => void
  animationProgress: number
  annimationTriggerRef: RefObject<HTMLDivElement>
}
